module.exports = __webpack_public_path__ + "9fc5211f6758df7ca16f4a07ee1c010a.svg";